import React from 'react';
import SectionHeader from '../SectionHeader.jsx';
import Classnames from 'classnames';
import _ from 'lodash';
import RegularInvstConstant from '../../../constants/RegularInvestmentPlanConstants.js';

export default class RegularInvestmentPlanReview extends React.Component {
    constructor(props) {
        super(props);
    }

    renderHeader() {
        return (<SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName} />);
    }

    renderSectionMessage(sectionMsg) {
        return (<div className="row simple-review-row-subsection">
                    <div className="col-xs-12">
                        <h5>{sectionMsg}</h5>
                    </div>
                </div>);
    }

    getTotalInvestQty() {
        let totalQty = 0;
        _.forEach(this.props.investOptionItems, (data) => {
            totalQty += parseFloat(data.weight);
        });

        return totalQty;
    }

    renderSimpleReview(data, idx) {
        const isContribution = data.label === RegularInvstConstant.Labels.personalContribution || data.label === RegularInvstConstant.Labels.spouseContribution || data.label === RegularInvstConstant.Labels.monthlyAmount;
        const colClass = Classnames('row', {'simple-review-row-subsection': data.subsection}, {'simple-review-row': !data.subsection});
        const col1 = isContribution ? Classnames('col-xs-9', {'label-header': data.header}) : Classnames('col-xs-4', {'label-header': data.header});
        const col2 = isContribution ? 'col-xs-3' : 'col-xs-8';
        const value = isContribution ? <div><span className="pull-left">$</span><span className="confirm-fyp__currency__rip">{data.value}</span></div> :
                                       <div className="simple-review-value">{data.value}</div>;

        if (data.label === 'Investment allocation') {
            const totalQty = this.getTotalInvestQty();
            const investmentAllocations = _.map(this.props.investOptionItems, (item, idx) => {
                return (
                    <div key={`rip_invstOpt_${idx}_row`} className="col-xs-12">
                        <div className="investment-allocation-item-rip row">
                            <div className="col-xs-8">
                                <p className="investment-allocation-item__title">{idx + 1}. {item.name}</p>
                                <p className="label-indent investment-allocation-item__code"># {item.code}</p>
                            </div>
                            <div className="col-xs-2 text-right">
                                <p>Allocation</p>
                                <p></p>
                            </div>
                            <div className="col-xs-2">
                                <p className="investment-allocation-item__amount">{item.weight} %</p>
                                <p className="investment-allocation-item__weight"></p>
                            </div>
                        </div>
                    </div>)
            });

            return (<div key={`rip_confirm_${idx}Investment_row`}>
                        <div className={colClass}>
                            <div className={col1}>
                                <span className={Classnames({ 'label-indent': data.indent })}>{ data.label }</span>
                            </div>
                        </div>
                        <div className="row simple-review-row-subsection">
                            {investmentAllocations}
                            {totalQty > 0 ?
                                <div className="col-xs-12">
                                    <div className="row">
                                        <div className="label-header col-xs-10 text-right">Total</div>
                                        <div className="label-header col-xs-2">{totalQty} %</div>
                                    </div>
                                </div>
                            :null}
                        </div>

                    </div>);
        } else {
            return (<div key={`rip_confirm_${idx}Details_row`} className={colClass}>
                        <div className={col1}>
                            <span className={Classnames({ 'label-indent': data.indent })}>{ data.label }</span>
                        </div>
                        <div className={col2}>
                            {value}
                        </div>
                    </div>);
        }
    }

    render() {
        let target = this;
        let items = this.props.items;
        let sectionMsg = (this.props.items && this.props.items.length === 1) ? '' : this.renderSectionMessage(this.props.sectionMessage);
        const sectionHeader = (this.props.items && this.props.items.length > 0) ? this.renderHeader() : null;
        const cpi =  _.filter(items, {label: RegularInvstConstant.Labels.yearlyIncrease});
        let itemsWithoutCpi = _.filter(items, (n) => { return n.label !== RegularInvstConstant.Labels.yearlyIncrease } );
        let sectionDetails = _.map(itemsWithoutCpi, function(i, idx) { return target.renderSimpleReview(i, idx); });
        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    {sectionHeader}
                    {sectionMsg}
                    <div>
                        {sectionDetails}
                    </div>
                    <div>
                        {cpi.length > 0 ?
                        <section className="row cpi">
                            <div className="col-xs-4 label-header">{cpi[0].label}</div>
                            <div className="col-xs-8">{ cpi[0].value }</div>
                        </section>
                        : null}
                    </div>
                </div>
            </section>
        )
    }
}

RegularInvestmentPlanReview.propTypes = {
    items: React.PropTypes.array.isRequired,
    sectionId: React.PropTypes.string,
    sectionName: React.PropTypes.string.isRequired,
    sectionMessage: React.PropTypes.string,
    investOptionItems: React.PropTypes.array.isRequired
};

RegularInvestmentPlanReview.defaultProps = {
    sectionMessage: ''
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/RegularInvestmentPlan/RegularInvestmentPlanReview.jsx